import { motion } from 'framer-motion';
import { useMemo } from 'react';

import useNavIconVariants from '../../lib/hooks/useNavIconVariants';

import { INavIcon } from './types';

export default function Edit2({ active, ...props }: INavIcon) {
  const variants = useNavIconVariants();

  const variant = useMemo(
    () => (active ? variants.active : variants.default),
    [active, variants]
  );

  return (
    <motion.svg
      initial={variants.default}
      animate={variant}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      width={20}
      height={20}
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        d="M4.48939 15.5117C4.88606 15.9084 5.71787 15.8699 6.38815 15.7543C7.05199 15.6398 7.63019 15.2638 8.10653 14.7874L14.6142 8.27972C14.6142 8.27972 16.7838 6.11011 15.3374 4.66371C13.891 3.2173 11.7214 5.38691 11.7214 5.38691L5.21372 11.8946C4.73738 12.3709 4.36129 12.9492 4.2468 13.613C4.13119 14.2833 4.09272 15.1151 4.48939 15.5117Z"
        fill="current"
        fillOpacity="0.08"
      />
      <path
        d="M11.7214 5.38691L5.21372 11.8946C4.73738 12.3709 4.36129 12.9492 4.2468 13.613C4.13119 14.2833 4.09272 15.1151 4.48939 15.5117C4.88606 15.9084 5.71787 15.8699 6.38815 15.7543C7.05199 15.6398 7.63019 15.2638 8.10653 14.7874L14.6142 8.27972M11.7214 5.38691C11.7214 5.38691 13.891 3.2173 15.3374 4.66371C16.7838 6.11011 14.6142 8.27972 14.6142 8.27972M11.7214 5.38691L14.6142 8.27972"
        stroke="current"
        strokeOpacity="0.4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </motion.svg>
  );
}
